import React, { useMemo } from 'react';
import { WMSLayerInfo } from '@ais-ui/websockets';
import {
  OSMTileLayer,
  BlueTileLayer,
  S57ToTileLayer,
  WMSTileLayer,
  wmsToTileLayer,
} from '@ais-ui/react-openlayers';
import { useSettings } from '../Settings/SettingsProvider';
import { useWMSSettings } from '../WMSLayers/useWMSSettings';
import { getOsmUrlHeadersFromSettings } from '../utils/getOsmUrlHeadersFromSettings';
import { getS57Url } from '../utils/getS57Url'; // Adjust the import paths

export const BaseMap = () => {
  const { settings } = useSettings();
  const wmsSettings = useWMSSettings();

  const { url: osmUrl, headers: osmHeaders } =
    getOsmUrlHeadersFromSettings(settings);

  const activeBaseMapId = settings['ribbonPlugin.settings'].active_base_map;

  const activeBaseMap = useMemo(() => {
    if (activeBaseMapId === 's57') {
      return S57ToTileLayer(getS57Url());
    }

    if (activeBaseMapId === 'blue') {
      return null;
    }

    for (const wmsInfo of wmsSettings.wmsInfos) {
      const wmsLayerInfo = wmsInfo.layers?.find(
        (layer: WMSLayerInfo) => layer.id === activeBaseMapId
      );
      if (wmsLayerInfo) {
        const tileLayer = wmsToTileLayer(wmsInfo, wmsLayerInfo);
        return tileLayer;
      }
    }
    return null;
  }, [wmsSettings.wmsInfos, activeBaseMapId]);

  if (activeBaseMapId === 'blue') {
    return <BlueTileLayer color="#aad3df"></BlueTileLayer>;
  }

  if (activeBaseMap) {
    return (
      <WMSTileLayer
        key={settings['ribbonPlugin.settings'].active_base_map}
        tileLayer={activeBaseMap}
      ></WMSTileLayer>
    );
  } else {
    return <OSMTileLayer url={osmUrl} headers={osmHeaders}></OSMTileLayer>;
  }
};
